import { createContext } from 'react';
import { FilterSearchKey } from 'components/filter/filters-next/FilterContext';

interface IFilterSectionContext extends Pick<FilterSearchKey, 'resource'> {}

const FilterSectionContext = createContext<IFilterSectionContext>({
    resource: 'contact',
});

export { FilterSectionContext };
export type { IFilterSectionContext };
